import { useQueryClient } from '@tanstack/react-query';

import { submitQuestionnaireAnswers } from '../../api/questionnaireSubmissions.api';
import { queryKeys } from '../../queryKeys';
import { useMutation } from '../base';

export function useSubmitQuestionnaireAnswers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitQuestionnaireAnswers,
    onSuccess: async (_data, { id }) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.questionnaireSubmissions.fetchPending().queryKey,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.questionnaireSubmissions.fetchById({ id })
            .queryKey,
        }),
        queryClient.invalidateQueries({
          exact: false,
          queryKey: queryKeys.schedule.fetchSchedule._def,
        }),
        queryClient.invalidateQueries({
          exact: false,
          queryKey:
            queryKeys.scheduleQuestionnaire.fetchScheduleQuestionnaires._def,
        }),
      ]);
    },
  });
}
